import memberReducer from './';

export default memberReducer;
